module.exports = __webpack_public_path__ + "static/img/user-menu-3.ff084ecc.png";